module.exports = __webpack_public_path__ + "static/media/scroll-icon.79d25e78.svg";